/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-01 10:53:58
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-09-28 09:39:04
 * @FilePath: /unifyxp-v2-store-portal/src/components/GlobalTooltip/WhiteBackgroundTooltip/index.tsx
 */
import React from 'react';
import css from './css.less';
import GlobalTooltip from 'src/components/GlobalTooltip/GlobalTooltip';
import { EnumPosition } from 'src/types/common/common';
export { EnumPosition };
const WhiteBackgroundTooltip = (props) => {
  const { children, overlayClassName, ...rest } = props;
  return (
    <GlobalTooltip
      overlayClassName={`${overlayClassName} ${css.tooltip}`}
      {...rest}>
      {children}
    </GlobalTooltip>
  );
};
export default WhiteBackgroundTooltip;
const TooltipContainer = (props) => {
  const { children, ...rest } = props;
  return (
    <div className={css.tooltipContainer} {...rest}>
      {children}
    </div>
  );
};
const TooltipTitle = (props) => {
  const { children, ...rest } = props;
  return (
    <div className={css.tooltipTitle} {...rest}>
      {children}
    </div>
  );
};
const TooltipContent = (props) => {
  const { children, ...rest } = props;
  return (
    <div className={css.tooltipContent} {...rest}>
      {children}
    </div>
  );
};
export { TooltipContainer, TooltipTitle, TooltipContent };
